import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-access-control-panel',
  templateUrl: './access-control-panel.component.html',
  styleUrls: ['./access-control-panel.component.css']
})
export class AccessControlPanelComponent implements OnInit {
  users: any = [];
  model: any = [];
  ModulesList: any = [];
  currentUser: any;

  constructor(
    private loginservice: LoginService,
    private _flashMessagesService: FlashMessagesService
  ) { }

  ngOnInit() {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.model.user_id = ''
    this.getUsers();
    this.getModules();
  }
  getUsers() {
    this.loginservice.getUsers(this.currentUser)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this.users = data['data'];
          } else {
            this.users = [];
          }
        },
        error => {
          alert('Network Error In Access Control component getUser API');
        });
  }

  getUserId(userId) {
    this.loginservice.getUserId(userId, this.currentUser)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this.model = data['data'];
            // Parse module_access from API
            let savedAccess = [];
            if (this.model.module_access) {
              try {
                savedAccess = JSON.parse(this.model.module_access);
              } catch (e) {
                console.error("Invalid module_access JSON", e);
              }
            }
            // Map saved access to ModulesList
            this.ModulesList.forEach(m => {
              const match = savedAccess.find(sa => sa.module_id == m.module_id);
              if (match) {
                m.access = true;
                m.Add = !!match.add;
                m.Edit = !!match.edit;
                m.View = !!match.view;
                m.Delete = !!match.delete;
                m.Upload = !!match.upload;
                m.Wallet = !!match.wallet;
              } else {
                m.access = false;
                m.Add = false;
                m.Edit = false;
                m.View = false;
                m.Delete = false;
                m.Upload = false;
                m.Wallet = false;
              }
            });
          } else {
            this.model = [];
          }
        },
        error => {
          alert('Network Error In Access control component getUserId API');
        });
  }


  getModules() {
    this.loginservice.getModules(this.currentUser)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this.ModulesList = data['data'].map(m => ({
              ...m,
              access: false,
              Add: false,
              Edit: false,
              View: false,
              Delete: false,
              Upload: false,
              Wallet: false
            }));
          } else {
            this.ModulesList = [];
          }
        },
        error => {
          alert('Network Error getModules API');
        });
  }


  save() {
    // take only checked modules
    const selectedModules = this.ModulesList.filter(m => m.access);

    // extract only module_ids
    const moduleIds = selectedModules.map(m => m.module_id).join(",");

    // prepare access details separately
    const access = selectedModules.map(m => ({
      module_id: m.module_id,
      add: !!m.Add,
      edit: !!m.Edit,
      view: !!m.View,
      delete: !!m.Delete,
      upload: !!m.Upload,
      wallet: !!m.Wallet
    }));

    // final payload
    const payload = {
      user_id: this.model.user_id,
      module_ids: moduleIds,
      access: JSON.stringify(access),
      salon_id: this.currentUser['salon_id']
    };

    this.loginservice.saveAccess(payload)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
            this._flashMessagesService.show('Please log out and log in again for the changes to take effect.', { cssClass: 'alert-success' });
            alert("Please log out and log in again for the changes to take effect.")
          } else {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
          }
        },
        error => {
          alert('Network Error saveAccess API');
        });

    // API call
    // this.loginservice.saveAccess(payload).subscribe(...)
  }


}



// WEBPACK FOOTER //
// ./src/app/access-control-panel/access-control-panel.component.ts